<template>
  <div class="navbar">
    <div class="left-menu">
      <Hamburger
        id="hamburger-container"
        :is-active="sidebar.opened"
        @toggle="toggleSideBar"
      />
      <Breadcrumb
        v-if="isDesktop"
        id="breadcrumb-container"
        class="breadcrumb-container"
      />
    </div>
    <slot name="right-menu" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Hamburger from '@/components/Hamburger.vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger
  },
  setup() {
    const appStore = useAppStore()
    const { isDesktop } = useResize()

    const sidebar = computed(() => {
      return appStore.sidebar
    })
    const device = computed(() => {
      return appStore.device.toString()
    })

    const toggleSideBar = () => {
      appStore.ToggleSideBar(false)
    }

    return { sidebar, toggleSideBar, isDesktop }
  }
})
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .left-menu {
    display: flex;
    align-items: center;
  }
}
</style>
